jQuery.noConflict();

jQuery(document).ready(function($) {
    // ラベルがクリックされたときにその内容を span に表示
    $(document).on('click', 'label.sc-kLwgWK', function() {
        const $label = $(this);
        const $planNameElement = $label.find('p.sc-ikJzcn');
        const text = $planNameElement.text().trim();
        const $span = $('.fixed-bottom-container .product-title span');

        // span 要素が存在する場合に内容を更新
        if ($span.length) {
            $span.text(' / ' + text); // text メソッドで更新
        }
    });

    function updateSelectedPlan() {
        const $checked = $('input[name="planOption"]:checked');

        if ($checked.length) {
            const $label = $('label[for="' + $checked.attr('id') + '"]');

            if ($label.length) {
                const $planNameElement = $label.find('p.sc-ikJzcn');

                if ($planNameElement.length) {
                    const text = $planNameElement.text().trim();
                    const $productTitleSpan = $('.fixed-bottom-container .product-title span');
                    
                    if ($productTitleSpan.length) {
                        $productTitleSpan.text(' / ' + text); // text メソッドで更新
                    }
                }
            }
        }
    }

    // 初回の1秒後に処理を実行
    setTimeout(function() {
        updateSelectedPlan();
    }, 1000);

    // ラジオボタンの変更時にプラン情報を更新
    $(document).on('change', 'input[name="planOption"]', function () {
        updateSelectedPlan();
    });
});
